// Interfaces
export interface CarInfo {
    carBody: string;
    carMake: string;
    carMiles: string;
    carModel: string;
    carModelTrim: string;
    carPrice: string;
    carStockAvailability: string;
    carYear: string;
    vin: string;
}

export const AdobePageName = {
    timedAuctionsPilot: 'Timed Auctions: Agreement',
    arbitrations: 'Member Dashboard: Arbitrations',
    myList: 'Member Dashboard:My List',
    vdp: 'Member Dashboard:Vehicle Details Page',
    search: 'Member Dashboard:Search',
    myTransactions: 'Member Dashboard:My Transactions',
    myProfile: 'Member Dashboard:My Profile',
    savedSearches: 'Member Dashboard:Saved Searches',
    authDash: 'Member Dashboard:Authenticated Dashboard',
    homepage: 'Homepage',
    aboutUs: 'About Us',
    policy: 'Policy',
    faq: 'FAQ',
    contact: 'Contact Us',
    locations: 'Locations',
    checkin: 'Checkin',
    checkout: 'Checkout',
    photoSurvey: 'PhotoSurvey',
    articles: 'Articles',
};

// Enums
const enum AdobeSiteSection {
    MemberDashboard = 'Member Dashboard',
    VehicleDetails = 'Vehicle Details',
    Homepage = 'Homepage',
}

const enum LinkAction {
    saveCar = 'saveCar',
    saveNoteComplete = 'saveNoteComplete',
    saveNoteInit = 'saveNoteInit',
    sorting = 'sorting',
    submitArbitration = 'submitArbitration',
    submitPhotoSurvey = 'submitPhotoSurvey',
}

// eslint-disable-next-line import/prefer-default-export
export { AdobeSiteSection, LinkAction };
